import { EboObject } from '../../base-classes/ebo-object';
import { ServiceProvider, TenantCredential } from '../../tenant';
import { Company } from './company';

export class CompanyCredential extends EboObject {
  companyId: string;
  company: Company;
  tenantCredentialId: string;
  tenantCredential: TenantCredential;

  constructor(jsonData?: Partial<CompanyCredential>) {
    super(jsonData);
    if (jsonData) {
      if (jsonData.company) {
        this.company = new Company(jsonData.company);
      }
      if (jsonData.tenantCredential) {
        this.tenantCredential = new TenantCredential(jsonData.tenantCredential);
      }
    }
  }

  get service(): ServiceProvider {
    return this.tenantCredential?.service;
  }
  set tenantCompanyName(value: string) {
    //NOP
  }
}
